function resizeGridItem(item) {
  const grid = document.querySelector("#product-grid");
  if (!grid) {
    return; // Stop function execution if the #product-grid is not found
  }
  const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'), 10);
  const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'), 10);
  const cardWrapper = item.querySelector('.card-wrapper');
  if (!cardWrapper) {
    return; // Skip this .grid__item if no .card-wrapper is found
  }
  const rowSpan = Math.ceil((cardWrapper.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
  item.style.gridRowEnd = "span " + rowSpan;
}

function resizeAllGridItems() {
  const allItems = document.querySelectorAll("#product-grid .grid__item");
  allItems.forEach(item => {
    resizeGridItem(item);
  });
}

// Bind resizeAllGridItems to window load and resize events
window.onload = resizeAllGridItems;
window.addEventListener("resize", resizeAllGridItems);
